import React from 'react';

import PropTypes from 'prop-types';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';

export type HeaderProps = StylableComponent<HTMLDivElement>;

const Header = React.forwardRef<HTMLDivElement, HeaderProps>(
  ({ children, className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={className}
        css={[
          {
            color: theme.colors.charcoal700,
            marginBottom: 8,
          },
          theme.typography.heading3,
          style,
        ]}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Header.displayName = 'Header';

Header.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Header content */
  children: PropTypes.node,
};

export default Header;
